import React from 'react'
import { Deal } from '../../../../types/dealType'

export const DealCard = ({item}:{item:Deal}) => {
    
  return (
    <div className='w-[13rem] cursor-pointer'>
        <img className='  rounded-t-lg  w-full h-[12rem] object-cover object-top' src={item.category.image} alt="" />
        <div className="border-4  rounded-b-lg border-slate-400 bg-slate-400 text-white p-2 text-center">
            <p className='text-lg font-semibold'>{item.category.name}</p>
            <p className='text-2xl font-bold'>{item.discount} OFF</p>
            <p className='text-balance text-lg'>Shop now</p>
        </div>
    </div>
  )
}
